import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { AvatarWithLabel, Box, Button, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useDocumentNoticeDate } from 'app/domains/metadata';
import { useActiveDocument } from 'shared/domains/documents';
import { localeConfig } from 'shared/domains/languages/config';
import { StyledCard } from './styled';
export function NoticeDate() {
    const { id: documentId } = useActiveDocument();
    const localeCode = localeConfig.getActiveLocale().code;
    const { data, savingData, update } = useDocumentNoticeDate({ documentId });
    const { localizedDate, value, warning } = data;
    if (!warning) {
        return null;
    }
    return (<Box mb="xl">
      <StyledCard>
        <Box p="2xl" flexDirection="column" gap="xl">
          <AvatarWithLabel solid title={t({
            message: 'Upcoming notice date',
            comment: 'Actionable insights: Document notice date title',
        })} subtitle={t({
            message: `Notice date is set to ${localizedDate}`,
            comment: 'Actionable insights: Document notice date title',
        })} size="xl" appearance="warning" alignment="vertical">
            <Falcon icon="circle-exclamation"/>
          </AvatarWithLabel>
          <Box alignItems="center" justifyContent="center" gap="xl">
            <Menu.Root target={<Button size="small" appearance="ghost" disabled={savingData}>
                  <Trans comment="Actionable insights: Update notice date">Update</Trans>
                </Button>}>
              <Menu.Calendar value={value} locale={localeCode} onChange={update}/>
            </Menu.Root>
          </Box>
        </Box>
      </StyledCard>
    </Box>);
}
